@import './pk-column-charts.variables';

@layer components {
  @keyframes animation-bar {
    from {
      transform: scaleY(0);
    }
  }
}

:host {
  @apply block;
  font-family: var(--column-charts--font-size);
}

.chart-container {
  @apply grid-cols-[repeat(var(--column-charts-columns-number),minmax(15px,1fr))];
}

.chart-item-bar {
  @apply mb-xs w-[5px] origin-[50%_100%] animate-[animation-bar_1s] rounded-full bg-[color:--column-charts-bar-item--color];
}
